import { render, staticRenderFns } from "./main.vue?vue&type=template&id=06535f6b&scoped=true"
var script = {}
import style0 from "./main.vue?vue&type=style&index=0&id=06535f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06535f6b",
  null
  
)

export default component.exports